import React, { useCallback, useRef } from 'react';
import { animated, useTransition } from 'react-spring';

import styles from './screen.module.scss';

function Screen({ children, component: Component, show, ...rest }) {
  const screenEl = useRef(null);
  const transitions = useTransition(show, null, {
    from: { opacity: 0, top: '180px' },

    enter: () => async (next) => {
      await new Promise((resolve) => setTimeout(resolve, 300));
      await next({ opacity: 1, top: '0' });
    },

    leave: { opacity: 0, top: '-100px' },
  });

  const scrollToTop = useCallback(() => {
    setTimeout(() => screenEl.current.scrollTo(0, 0), 10);
  }, [screenEl]);

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <animated.div ref={screenEl} key={key} className={styles.screen} style={props}>
          <Component {...rest} scrollToTop={scrollToTop} />
        </animated.div>
      ),
  );
}

export default Screen;
